import moment from 'moment';
import { cooperplaceApi } from 'services/api';
import { toReplacementPayload } from 'v3/components/FreightValues/utils';
import { convertNumberToDatabase } from 'v3/utils/formatter';

export async function handleCreate(
  data,
  tollsPlazaInfos,
  freightValues,
  replacementFreightValues,
  setLoading,
  setShowModal,
  setRegisteredLoad,
) {

  const saveTollsPlaza = async (tollsPlaza, loadId) => {
    try {
      const payload = {
        loadId: loadId,
        requestError: tollsPlaza?.requestError,
        tollsPlaza: tollsPlaza?.tollsPlaza,
        totalsTollsPlaza: {
          totalTollValue: tollsPlaza?.totalTollValue,
          totalTollTagValue: tollsPlaza?.totalTollTagValue,
          totalKm: tollsPlaza?.totalKm,
          expectedTime: tollsPlaza?.expectedTime,
          identifierHistory: tollsPlaza?.identifierHistory,
          codPolilyne: tollsPlaza?.codPolilyne,
          totalAxes: tollsPlaza?.totalAxes,
        }
      };
      const response = await cooperplaceApi.post('tollsPlaza/insert-tolls-plaza-load', payload);

      return response.data;

    } catch (error) {
      // ignore
    }
  };

  try {
    let originList = {};
    let destinationList = {};
    let payload = {};
    const serializePolylineWaypoints = polylineWaypoints => {
      if (!polylineWaypoints) return null;
      if (typeof polylineWaypoints === 'string') return polylineWaypoints;
      return JSON.stringify(polylineWaypoints);
    };

    const replacementPayload =
      data?.isReplacement &&
      replacementFreightValues &&
      toReplacementPayload(replacementFreightValues);

    const toDestination = (destination) => ({
      address: destination.address,
      number: destination.number,
      complement: destination.complement,
      zipCode: destination.zipCode,
      lat: destination.lat,
      lng: destination.lng,
      cityId: destination.city?.id,
      city: destination.city?.name,
      province: destination.province,
      neighborhood: destination.neighborhood,
      formattedAddress: destination.formatted_address,
      scheduledTime: moment(destination.scheduled_time).toDate(),
      startSchedule: moment(destination.start_schedule).toDate(),
      countrySlug: destination.country?.abbreviation,
      clientId: destination.clientId || null,
    });

    originList = toDestination(data.origin);
    destinationList = data.destinations.map((dest) => ({
      ...toDestination(dest),
      action: dest.type.id,
    }));
    payload = {
      totalDistanceInKm: data.totalDistanceInKm,
      policyId: data?.policyId,
      negotiationType: freightValues?.negotiationType?.value,
      policyRangeId: data?.policyRangeId,
      policyOperationId: data?.policyOperationId,
      policyVehicleId: data?.policyVehicleId,
      negotiatorId: data.negotiator[0]?.id,
      isReplacement: data?.isReplacement,
      personClientId: data.client.id,
      productId: data.product.id,
      container: data.container,
      branchOfficeId: data.branchOffice?.id,
      costCenterId: data.costCenter?.id,
      takerValue: freightValues?.customer?.takerValue?.value,
      negotiationId: data?.negotiation?.id || null,
      dispositionId: data?.disposition.id,
      contactInfo: `+${data.country.ddi} ${data.phone}`,
      currency: freightValues?.currency?.value || 'BRL',
      loadWeight: +convertNumberToDatabase(data.weight),
      dueDate: data.dueDate ? moment(data.dueDate) : null,
      clientOrderNumber: data?.clientOrderNumber || null,
      externalInvoiceNumber: data?.externalInvoiceNumber || null,
      comments: data.observations,
      crawledLoad: data.tracked,
      tolledLoad: data?.isTollIncluded || null,
      tollValue: freightValues?.customer?.tollValue?.value,
      netWeight: +convertNumberToDatabase(data.netWeight),
      dischargeValue: freightValues?.customer?.dischargeValue?.value,
      insuranceValue: freightValues?.discounts?.coopercargaInsurance?.value,
      mopp: data.mopp ? 1 : 0,
      gris: freightValues?.customer?.gris?.value,
      adValorem: freightValues?.customer?.adValorem?.value,
      advaloremIncluded: data.isAdValoremIncluded | null,
      ferry: freightValues?.customer?.ferry?.value,
      icms: freightValues?.customer?.ICMS?.value,
      chargeValue: freightValues?.customer?.chargeValue?.value,
      palletNumber: data.pallets || null,
      isEscorted: data?.escorted,
      pcpObservation: freightValues?.shipmentTransfers?.pcpObservation,
      totalShipmentTransfer: freightValues?.shipmentTransfers?.total,
      totalInputs: freightValues?.discounts?.total,
      totalShipmentDiscounts: freightValues?.shipmentDiscounts?.total,
      icmsPercentage: freightValues?.customer?.ICMS?.percentage,
      grisPercentage: freightValues?.customer?.gris?.percentage,
      adValoremPercentage: freightValues?.customer?.adValorem?.percentage,
      trackerId: data.tracker ? data.tracker.id : null,
      withBait: data.withBait,
      baitNumber: data.baitNumber ? data.baitNumber : null,
      isTollPayerClient: data?.isTollPayerClient || 0,
      unloadIncluded: data?.isDischargeIncluded || null,
      chargeIncluded: data?.isChargeIncluded || null,
      fareCompany: freightValues?.fareCompany,
      productTypeId: data.product.product_type_id,
      cargoValue: +data?.cargoValue,
      loadVolume: String(data.volume),
      insuranceIncluded: data.isInsuranceIncluded || null,
      typeValue: data?.freightType?.value,
      grisIncluded: data.isGrisIncluded || null,
      adValoremIncluded: data.isAdValoremIncluded | null,
      exchange: +data?.dailyCotation || 0,
      loadCurrency: data?.load_currency?.value,
      routeId: data?.routes?.id || null,
      crt: data?.crt,
      temperature: data?.temperature || null,
      temperatureMin: data?.temperatureMin || null,
      freightExchange: freightValues?.freightExchange,
      exchangeDay: freightValues?.exchangeDay,
      totalTakerValue: freightValues?.customer?.total,
      loadValueType: freightValues?.loadValueType?.value,
      actionTollId: freightValues?.customer?.tollValue?.action?.id || null,
      actionDischargeId: freightValues?.customer?.dischargeValue?.action?.id || null,
      actionChargeId: freightValues?.customer?.chargeValue?.action?.id || null,
      actionGrissAdvaloremId: freightValues?.customer?.gris?.action?.id || null,
      actionIcmsId: freightValues?.customer?.ICMS?.action?.id || null,
      actionFerryId: freightValues?.customer?.ferry?.action?.id || null,
      negotiatorIds: data.negotiator.map(item => item.id),
      polylineRoute: data?.polylineRoute || null,
      polylineWaypoints: serializePolylineWaypoints(data?.polylineWaypoints),
      extraFields:
        freightValues?.customer?.extras?.length > 0
          ? freightValues?.customer?.extras?.map(extra => {
            return {
              label: extra?.label,
              type: 0,
              value: extra?.value,
              showToDriver: extra?.showToDriver,
            };
          })
          : null,
      vehicleTypeIds: data?.vehicleTypes?.map((type) => type.id),
      vehicleImplementTypeIds: data?.vehicleImplements
        ? data?.vehicleImplements.map((implement) => implement.id)
        : [],
      vehicleBodyTypeIds: data?.vehicleBodies?.map((body) => body.id),
      tagIds: data?.tags ? data?.tags?.map((tag) => tag.id) : null,
      automationIds: data.selectedAutomations.map((automation) => automation.id),
      riskManagerIds: [],
      loadOrigins: originList,
      loadDestinations: destinationList,
      replacements: data?.isReplacement ? [replacementPayload] : [],
      searchDriver: data?.searchDriver ? 0 : 1,
      searchDriverRadius: data?.searchDriverRadius,
      loadPublish: data?.loadPublish,
    };
    let load;

    for (let i = 0; i < data.loadCreationNumber; i++) {
      let response;
      response = await cooperplaceApi.post(`loads`, payload);

      load = response.data.id;

      const inputsExtraFields = [
        ...freightValues?.discounts?.extras.map((item) => ({
          ...item,
          manual: true,
        })),
      ];
      const transferExtraFields = [
        ...freightValues?.shipmentTransfers?.extras.map((item) => ({
          ...item,
          manual: true,
        })),
      ];
      const discountsExtraFields = [
        ...freightValues?.shipmentDiscounts?.extras.map((item) => ({
          ...item,
          manual: true,
        })),
      ];

      const issueRateAsExtraField = {
        label: 'Taxa de emissão',
        manual: true,
        value: freightValues?.shipmentDiscounts?.issueRate,
        showToDriver: false,
      };
      discountsExtraFields.push(issueRateAsExtraField);

      const hasCoopercargaInsurance = !!freightValues?.discounts?.coopercargaInsurance?.value;

      if (hasCoopercargaInsurance && freightValues?.discounts?.coopercargaInsurance?.value > 0) {
        const newInputsExtraField = {
          label: 'Seguro Coopercarga',
          manual: true,
          value: freightValues?.discounts?.coopercargaInsurance?.value,
          showToDriver: false,
        };
        inputsExtraFields.push(newInputsExtraField);
      }
      try {
        await cooperplaceApi.put('/carg-inputs', {
          loadId: load,
          inputsExtraFields,
        });
        await cooperplaceApi.put('carg-shipment-transfers/', {
          loadId: load,
          transferExtraFields,
        });
        await cooperplaceApi.put('carg-shipment-discounts/', {
          loadId: load,
          discountsExtraFields,
        });

        if (load) {
          await saveTollsPlaza(tollsPlazaInfos, load);
        }

      } catch (err) {
        console.error(err);
      }
    }
    setShowModal(true);
    setRegisteredLoad(load);
    setLoading(false);
  } catch (error) {
    setLoading(false);
    throw error;
  }
}

export function validateDestinationsStartDate(destinations) {
  if (!destinations || destinations.length <= 1) return true;
  const invalidsDates = [];

  for (let i = 0; i < destinations.length - 1; i++) {
    const nextStartScheduleTime = moment(destinations[i + 1].start_schedule, 'YYYY-MM-DDTHH:mm');
    const currentScheduledTime = moment(destinations[i].start_schedule, 'YYYY-MM-DDTHH:mm');

    if (currentScheduledTime >= nextStartScheduleTime) {
      invalidsDates.push(i);
    }
  }

  return invalidsDates;
}

export function validateDestinationsEndDate(destinations) {
  if (!destinations || destinations.length <= 1) return true;
  const invalidsDates = [];

  for (let i = 1; i < destinations.length; i++) {
    const previousScheduledTime = moment(destinations[i - 1].scheduled_time, 'YYYY-MM-DDTHH:mm');
    const currentScheduledTime = moment(destinations[i].scheduled_time, 'YYYY-MM-DDTHH:mm');
    if (currentScheduledTime <= previousScheduledTime) {
      invalidsDates.push(i);
    }
  }

  return invalidsDates;
}

export function validateDestinationDate(destinations) {
  if (!destinations || destinations.length <= 1) return true;
  const invalidsDates = [];
  let destArray = destinations.slice(0, destinations?.length - 1);

  for (let i = destinations.length - 1; i > 0; i--) {
    const invalidDate = destArray.some((item) => {
      const previousScheduledTime = moment(item.scheduled_time, 'YYYY-MM-DDTHH:mm');
      const currentScheduledTime = moment(destinations[i].start_schedule, 'YYYY-MM-DDTHH:mm');
      return previousScheduledTime > currentScheduledTime;
    });
    if (invalidDate) {
      invalidsDates.push(i);
    }
    destArray = destArray.slice(0, destArray?.length - 1);
  }
  return invalidsDates;
}

export function validateDestinationDateWithOrigin(origin, destinations) {
  const invalidsEndDates = [];
  const invalidsStartDates = [];
  const originStart = moment(origin.start_schedule, 'YYYY-MM-DDTHH:mm');
  const originEnd = moment(origin.scheduled_time, 'YYYY-MM-DDTHH:mm');
  destinations.forEach((dest, idx) => {
    const currentStartScheduledTime = moment(dest.start_schedule, 'YYYY-MM-DDTHH:mm');
    const currentEndTime = moment(dest.date, 'YYYY-MM-DDTHH:mm');
    if (currentStartScheduledTime < originStart) {
      invalidsStartDates.push(idx);
    }
    if (currentEndTime < originEnd) {
      invalidsEndDates.push(idx);
    }
  });
  return { start: invalidsStartDates, end: invalidsEndDates };
}

export function handleInitializeSingleOption(optionsArray, field, setter, isMultipleField = false) {
  if (optionsArray?.length === 1) {
    setter((old) => ({
      ...old,
      [field]: isMultipleField ? optionsArray : optionsArray[0],
    }));
  }
}
